<template>
  <div class="zt-slider relative h-full w-full">
    <div
      v-if="shouldShowHeader"
      class="zt-slider-control flex w-full items-center justify-between bg-zt-dark-200 px-4"
    >
      <slot
        name="header"
        :currenPosition="currenPosition"
        :totals="totals"
        :goTo="goTo"
        :isLastSlide="isLastSlide"
        :isFirstSlide="isFirstSlide"
      ></slot>
    </div>
    <div
      v-else
      class="zt-slider-control flex w-full items-center justify-between bg-zt-dark-200 px-4"
    >
      <div>
        <button
          v-if="buttonFullscreen"
          class="flex items-center justify-center rounded hover:bg-zt-dark-300 focus:outline-none"
          @click="$emit('slide-fullscreen')"
        >
          <zt-icon name="expand-outline" />
        </button>
      </div>
      <div class="flex items-center">
        <span class="px-4 leading-none"
          >Página {{ currenPosition }} de {{ totals }}</span
        >
        <button
          :disabled="isFirstSlide"
          class="mr-1 flex items-center justify-center rounded hover:bg-zt-dark-300 focus:outline-none"
          @click="goTo(-1)"
        >
          <zt-icon name="angle-left" />
        </button>
        <button
          :disabled="isLastSlide"
          class="ml-1 flex items-center justify-center rounded hover:bg-zt-dark-300 focus:outline-none"
          @click="goTo(1)"
        >
          <zt-icon name="angle-right" />
        </button>
      </div>
    </div>
    <div class="zt-slider-wrapper h-full w-full overflow-hidden bg-zt-dark-400">
      <div class="h-full w-full">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ztSlider',
  inheritAttrs: false,
}
</script>

<style
  scoped
  lang="css"
  src="../../../../../src/styles/components/ztSlider.css"
></style>
